import React from 'react';
import './RewardCard.scss';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const RewardCard = ({ name, count, attribute, info, icon, date }) => {
  const flagCardContent = (
   
    <div class="flag-card">
      <div class="flag-card__flag">
        <img class="milestone_flag" src={icon} alt="Milestone Badge"/>
      </div>
      <div class="flag-card__content">
        <div class="flag-card__text">
          <span class="flag-card__title">{attribute}:</span>
          {!date && <span class="flag-card__amount">{count}</span>}
        </div>
        {date &&
        <div class="flag-card__details">
          <span class="flag-card__amount">{count}</span>
          <div class="flag-card__date-section">{date}</div>
        </div>}
        </div>
      </div>
  );

  return (
    info ? (
      <Tippy
        content={
          <div>
            <h3 className="flag-card__title">
              {info}<span role="img" aria-label="celebration">🎉</span>
            </h3>
          </div>
        }
        arrow={true}
        placement="top"
        offset={[0, 10]}
        animation="shift-toward"
        theme="light"
      >
        {flagCardContent}
      </Tippy>
    ) : (
      flagCardContent
    )
  );
};

export default RewardCard;
